export const INTERNAL_ALL_RECORDS = 'searchString';

const INTERNAL_TO_URL_FIELD: { [internal: string]: string } = {
  productName: 'name',
  productCode: 'code',
  manufacturer: 'manufacturer'
};

const URL_FIELD_TO_INTERNAL: { [urlField: string]: string } = {
  name: 'productName',
  code: 'productCode',
  manufacturer: 'manufacturer'
};

const LEGACY_P_TO_INTERNAL: { [p: string]: string } = {
  productName: 'productName',
  productCode: 'productCode',
  manufacturer: 'manufacturer',
  all: INTERNAL_ALL_RECORDS,
  searchString: INTERNAL_ALL_RECORDS
};

export interface RestoredSearch {
  internalParameter: string;
  value: string;
}

export function buildSearchQueryParams(internalParameter: string, value: string): { q?: string; by?: string } {
  const urlField = INTERNAL_TO_URL_FIELD[internalParameter];
  if (!urlField || !value) {
    return {};
  }
  return { q: value, by: urlField };
}

function readParam(raw: any): string | null {
  return typeof raw === 'string' ? raw : null;
}

export function parseSearchQueryParams(queryParams: { [key: string]: any }): RestoredSearch | null {
  const by = readParam(queryParams['by']);
  const q = readParam(queryParams['q']);
  if (by === 'all') {
    return { internalParameter: INTERNAL_ALL_RECORDS, value: '' };
  }
  if (by && URL_FIELD_TO_INTERNAL[by] && q) {
    return { internalParameter: URL_FIELD_TO_INTERNAL[by], value: q };
  }

  const p = readParam(queryParams['p']);
  const v = readParam(queryParams['v']);
  const legacyInternal = p ? LEGACY_P_TO_INTERNAL[p] : null;
  if (legacyInternal === INTERNAL_ALL_RECORDS) {
    return { internalParameter: INTERNAL_ALL_RECORDS, value: '' };
  }
  if (legacyInternal && v) {
    return { internalParameter: legacyInternal, value: v };
  }

  return null;
}